import { useParams, useNavigate } from "react-router-dom";
import { MOCK_VENUES, MOCK_ACTIVITIES } from "@/lib/mockData";
import { ArrowLeft, MapPin, QrCode, Sparkles } from "lucide-react";
import ActivityCard from "@/components/ActivityCard";

const VenueDetail = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const v = MOCK_VENUES.find((x) => x.id === id) || MOCK_VENUES[0];
  const activitiesHere = MOCK_ACTIVITIES.filter((a) => a.venue?.id === v.id);

  return (
    <div data-testid="venue-detail-page">
      <div className="relative -mx-4 mt-4">
        <img src={v.image} alt={v.name} className="w-full h-64 object-cover border-b-2 border-[#0A0A0A]" />
        <button onClick={() => nav(-1)} className="absolute top-4 left-4 w-10 h-10 brutal-border rounded-full bg-white flex items-center justify-center brutal-shadow-sm" data-testid="venue-back">
          <ArrowLeft className="w-4 h-4" />
        </button>
      </div>

      <div className="mt-5">
        <span className="label-mono text-[#555555]">{v.category}</span>
        <h1 className="font-heading font-black text-3xl leading-tight">{v.name}</h1>
        <div className="flex items-center gap-1 text-sm text-[#555555] mt-1">
          <MapPin className="w-4 h-4" /> {v.address} • <span className="font-bold text-[#0A0A0A]">{v.distance_km} km</span>
        </div>
      </div>

      {v.deal && (
        <div className="brutal-card p-5 mt-4" style={{ background: v.deal.color }}>
          <div className="label-mono mb-1">Active deal</div>
          <div className="font-heading font-black text-2xl">{v.deal.label}</div>
          <p className="text-sm text-[#555555] mt-2">Group up and check in via QR to redeem.</p>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3 mt-4">
        <button className="brutal-btn bg-[#FF6A2C] text-white py-3 flex items-center justify-center gap-2" data-testid="venue-create-activity">
          <Sparkles className="w-4 h-4" /> Host here
        </button>
        <button className="brutal-btn bg-white py-3 flex items-center justify-center gap-2" data-testid="venue-checkin">
          <QrCode className="w-4 h-4" /> Check in
        </button>
      </div>

      <h3 className="font-heading font-bold text-xl mt-6 mb-3">Activities here</h3>
      <div className="space-y-4">
        {activitiesHere.length === 0 && (
          <div className="brutal-card p-6 text-center text-sm text-[#555555]">No activities here yet. Host the first.</div>
        )}
        {activitiesHere.map((a, i) => <ActivityCard key={a.id} activity={a} index={i} />)}
      </div>
    </div>
  );
};

export default VenueDetail;
